import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Popconfirm } from "antd";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchSelect from "components/common/SearchSelect";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
    getHeaders,
    getHeaderById,
    deleteHeaderById
} from "api/menu/master-files/question-library/actions";
import {
    getJobs
} from "api/menu/master-files/report-builder/actions";

const CreateHeader = React.lazy(() =>
    import("components/menu/master-files/question-library/create-header-modal"));

class ListHeaders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            jobOptions: this.props.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            })),
            currentJob: null
        };

        this.getColumns = this.getColumns.bind(this);
        this.handleEditModal = this.handleEditModal.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.props.getJobs();
        this.props.getHeaders(false, true);
    }

    componentWillReceiveProps(nextProps) {
        const newStates = {};
        if (!_.isEqual(nextProps.jobs, this.props.jobs)) {
            newStates.jobOptions = nextProps.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            }));
        }

        if (Object.keys(newStates).length) {
            this.setState(newStates);
        }
    }

    getColumns = () => [
        {
            Header: "QID",
            accessor: "id",
            width: 80,
        },
        {
            Header: "Question Text",
            accessor: "text",
            Cell: ({ original }) => (
                typeof original.text === "string"
                    ? original.text.split("\n").map((item, key) =>
                        <React.Fragment key={key}>
                            {item}<br/>
                        </React.Fragment>)
                    : original.text
            ),
            style: {
                whiteSpace: "unset"
            }
        },
        {
            Header: "Active?",
            id: "isInactive",
            accessor: original => (original.isInactive ? "No" : "Yes"),
            Cell: ({ original }) => (original.isInactive ? "No" : "Yes"),
            headerClassName: "text-left",
            Filter: ({ filter, onChange }) => (
                <ReactTableFilterSelect
                    currentValue={filter ? filter.value : ""}
                    onChange={value => onChange(value)}
                    style={{
                        width: "100%",
                        height: "100%"
                    }}
                    optionsObject={{
                        "": "Show All",
                        YES: "Yes",
                        NO: "No"
                    }}
                />
            ),
            width: 100,
        },
        {
            Header: "Actions",
            id: "actions",
            className: "text-right",
            Cell: ({ original }) => (
                <ButtonGroup>
                    <Button size="sm" onClick={() => this.handleEditModal(original.id)}>
                        <FontAwesomeIcon icon="pen" title="Update" />
                    </Button>
                    <Popconfirm
                        title={`Delete "${original.id}"?`}
                        onConfirm={() => this.handleDelete(original.id)}
                        placement="bottomRight"
                        okText="Yes"
                        cancelText="Cancel"
                    >
                        <Button variant="danger" size="sm">
                            <FontAwesomeIcon icon="times" />
                        </Button>
                    </Popconfirm>
                </ButtonGroup>
            ),
            filterable: false,
            width: 80
        }
    ];

    handleChangeJob = (option) => {
        this.setState({
            currentJob: option
        }, () => {
            const jobId = option ? option.value : false;
            this.props.getHeaders(jobId, true);
        });
    };

    handleEditModal = (questionId) => {
        const modalObj = {
            id: "create-edit-header",
            modalSettings: {
                size: "sm",
            },
            header: `${questionId ? "Update" : "Create"} Header`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <CreateHeader
                        onSave={() => this.props.closeCustomModal(modalObj)}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        questionId={questionId}
                        jobId={this.state.currentJob ? this.state.currentJob.value : false}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleDelete = (id) => {
        this.props.deleteHeaderById(id);
    };

    render() {
        const {
            loading,
            qlHeaders
        } = this.props;
        const {
            currentJob,
            jobOptions
        } = this.state;

        return (
            <div className="clearfix">
                <div className="form-inline d-flex justify-content-between pt-3 pb-3">
                    <div className="form-group">
                        <label className="mr-2">Job:</label>
                        <div style={{ width: 200 }} >
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={false}
                                isSearchable={true}
                                options={jobOptions}
                                value={currentJob}
                                onChange={this.handleChangeJob}
                            />
                        </div>
                    </div>

                    <div>
                        <button
                            className="btn btn-success"
                            onClick={() => this.handleEditModal()}
                        >
                            New Header
                        </button>
                    </div>
                </div>
                <ReactTable
                    data={qlHeaders}
                    columns={this.getColumns()}
                    headerClassName="table-header"
                    showPagination={true}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable={true}
                    defaultFiltered={[{
                        id: "isInactive",
                        value: "YES"
                    }]}
                    defaultSorted={[{
                        id: "id",
                        desc: true
                    }]}
                    defaultFilterMethod={filterCaseInsensitive}
                    style={{
                        height: "calc(100vh - 180px)",
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    jobs: state.reportBuilder.jobs,

    loading: state.questionLibrary.loading,
    qlHeaders: state.questionLibrary.qlHeaders,
    qlHeadersSingle: state.questionLibrary.qlHeadersSingle,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getJobs: bindActionCreators(getJobs, dispatch),

    getHeaders: bindActionCreators(getHeaders, dispatch),
    getHeaderById: bindActionCreators(getHeaderById, dispatch),
    deleteHeaderById: bindActionCreators(deleteHeaderById, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListHeaders);
